"use client";
import React from "react";
import { useContext } from "react";
import { RecentLeaderContext } from "@/components/server/RecentLeaderBoardContainer/context";
import OddRateStats from "./OddRateStats";

const OddStatistic = ({ oddStats }) => {
  const { home , away } = useContext(RecentLeaderContext);
  
  return (
    <>
      <OddRateStats home={home} away={away} oddStats={oddStats} />
    </>
  );
};

export default React.memo(OddStatistic);
